define(["./monitoringTripOverviewModule"], function (module) {
    "use strict";

    return module.controller("monitoringTripOverviewController", [
        "$scope",
        function ($scope) {
            $scope.currentDashboard =   {
                dashboardSourceId: ""
            };
        }]);
});